import { serverWhiteFileGetHidden } from './server-white';

async function fileGetHidden(fileid) {
  const res = await serverWhiteFileGetHidden.get(`/file/get?id=${fileid}`);
  return res;
}

export { fileGetHidden };
